import { DataIpAccessRules } from "../@types"

export const IP_ACCESS_RULES_MODAL_STATE = "IP_ACCESS_RULES_MODAL_STATE"
export const GET_IP_ACCESS_RULES_FOR_UPDATE = "GET_IP_ACCESS_RULES_FOR_UPDATE"
export const IS_IP_ACCESS_RULES_FOR_UPDATE = "IS_IP_ACCESS_RULES_FOR_UPDATE"
export const SWITCH_IP_ACCESS_RULES_REFRESH_TABLE = "SWITCH_IP_ACCESS_RULES_REFRESH_TABLE"

export interface IIpAccessRulesModalState {
  type: typeof IP_ACCESS_RULES_MODAL_STATE
}

export interface IGetIpAccessRulesForUpdate {
  type: typeof GET_IP_ACCESS_RULES_FOR_UPDATE
  payload: DataIpAccessRules
}

export interface IIsIpAccessRulesForUpdate {
  type: typeof IS_IP_ACCESS_RULES_FOR_UPDATE
  payload: boolean
}

export interface ISwitchIpAccessRulesRefreshTable {
  type: typeof SWITCH_IP_ACCESS_RULES_REFRESH_TABLE
  payload: boolean
}
